// extracted by mini-css-extract-plugin
export var ctas = "CruiseDrawerPriceAndOffers-module--ctas--bef32";
export var isSticky = "CruiseDrawerPriceAndOffers-module--is-sticky--bae1c";
export var noPromos = "CruiseDrawerPriceAndOffers-module--no-promos--98dcc";
export var offerTitle = "CruiseDrawerPriceAndOffers-module--offer-title--bbdbe";
export var priceAndOffers = "CruiseDrawerPriceAndOffers-module--price-and-offers--768a5";
export var priceRow = "CruiseDrawerPriceAndOffers-module--price-row--18ce2";
export var promoBadges = "CruiseDrawerPriceAndOffers-module--promo-badges--bd4dd";